// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TransactionAttemptRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TransactionAttemptRow — one step in the per-charge attempt
 * history for GET /subscriptions/(:num)/transactions.
 *
 * Attempts are ordered chronologically (created_at ASC) so the caller sees
 * the full pending → confirmed/failed sequence for a given provider_charge_id.
 * created_at is an ISO-8601 UTC string (controller converts GMT-3 before
 * populating the parent TransactionRow::$attempts array).
 */
import { registerContract } from './validate'

export interface Subscriptions_TransactionAttemptRow {
status?: string
event_type?: string
created_at?: string
}

registerContract('Subscriptions_TransactionAttemptRow', {
  status:     { type: 'string',  required: false },
  event_type: { type: 'string',  required: false },
  created_at: { type: 'string',  required: false },
})
